<div class="body-wrapper">
  <!--First Row-->
  <div class="row">
    <!--[routerLink]="['/configProduct/configure']"-->
    <div class="box-container col-xs-12 col-sm-6 col-md-3" *ngFor="let product of productConfigurations">
      <a class="swing-entrances-link" [routerLink]="['/build-and-buy/buildConfiguredProduct',product.id]">
        <div class="boxTitle">
          <h4>
            {{product.description}}
          </h4>
        </div><!--end title-->
        <div class="boxBody">
          <!--<img src="{{product.imageUrl}}" alt="{{product.imageUrl}}" width="250" height="200">-->
          <img src="{{product.imageUrl}}" width="250" height="200">
        </div><!--end boxBody-->
      </a>
    </div><!--end col-->

  </div>
</div>
